module.exports = __webpack_public_path__ + "static/media/default-property-image.71d2e32a.svg";